import { useMemo, useState } from "react";
import { Bell, SlidersHorizontal } from "lucide-react";
import { api } from "@/lib/api";
import { CardTitle, Field, useSave } from "./ProfileCard";

const ALERTS = [
  ["match", "Match alerts"],
  ["lineup", "Lineup alerts"],
  ["value", "Value pick alerts"],
  ["promotions", "News & offers"],
];

const usePrefsSave = (onSaved) => {
  const [busy, run] = useSave(onSaved);
  return [busy, (prefs, message) => run(() => api.put("/account/preferences", prefs), message)];
};

export function PreferencesCard({ data, onSaved }) {
  const [prefs, setPrefs] = useState(data.prefs);
  const [busy, save] = usePrefsSave(onSaved);
  const zones = useMemo(() => (Intl.supportedValuesOf ? Intl.supportedValuesOf("timeZone") : [data.prefs.timezone]), [data.prefs.timezone]);
  const set = (k) => (e) => setPrefs({ ...prefs, [k]: e.target.value });
  return (
    <section className="as-card" data-testid="preferences-card">
      <CardTitle icon={SlidersHorizontal}>Preferences</CardTitle>
      <form className="as-fields" onSubmit={(e) => { e.preventDefault(); save({ ...prefs, alerts: data.prefs.alerts }, "Preferences saved"); }}>
        <Field label="Default sport"><select disabled value="basketball" data-testid="pref-sport-select"><option value="basketball">Basketball (NBA)</option></select></Field>
        <Field label="Timezone" hint="Game times are shown in this timezone">
          <select value={prefs.timezone} onChange={set("timezone")} data-testid="pref-timezone-select">
            {zones.map((z) => <option key={z} value={z}>{z.replace(/_/g, " ")}</option>)}
          </select>
        </Field>
        <Field label="Language" hint="Saved for later — the app is in English for now">
          <select value={prefs.language} onChange={set("language")} data-testid="pref-language-select">
            <option value="en">English</option>
            <option value="el">Ελληνικά</option>
          </select>
        </Field>
        <button className="as-primary" disabled={busy} data-testid="pref-save-btn">Save preferences</button>
      </form>
    </section>
  );
}

export function NotificationsCard({ data, onSaved }) {
  const [alerts, setAlerts] = useState(data.prefs.alerts);
  const [busy, save] = usePrefsSave(onSaved);
  return (
    <section className="as-card" data-testid="notifications-card">
      <CardTitle icon={Bell}>Notifications</CardTitle>
      {ALERTS.map(([k, label]) => (
        <label className="as-toggle" key={k}>
          <span>{label}</span>
          <input type="checkbox" role="switch" checked={!!alerts[k]} onChange={(e) => setAlerts({ ...alerts, [k]: e.target.checked })} data-testid={`alert-${k}-toggle`} />
        </label>
      ))}
      <p className="as-muted">Saved now; alerts start sending once they launch.</p>
      <button type="button" className="as-secondary" disabled={busy} onClick={() => save({ ...data.prefs, alerts }, "Notifications saved")} data-testid="alerts-save-btn">
        Save notifications
      </button>
    </section>
  );
}
